import React from "react";
import { HoverCard, HoverCardTrigger, HoverCardContent } from "@/components/ui/hover-card";
import { Eye } from "lucide-react";
import { RequisitosChips, RequisitosDetalle } from "@/components/espacios/RequisitosForm";

/** Línea operativa compacta de la tarjeta: «Duratrans · 231×219 · 👥2 · ⚠ Alta · antes 10:00». Sólo si hay datos. */
export function ResumenOperativo({ m, testId }) {
  const mat = m.material_principal?.texto;
  const med = m.zona?.ancho_cm && m.zona?.alto_cm ? `${Math.round(m.zona.ancho_cm)}×${Math.round(m.zona.alto_cm)}` : null;
  const req = m.requisitos_montaje;
  if (!mat && !med && !req) return null;
  return (
    <div className="flex items-center gap-1 flex-wrap mt-0.5 text-[10px]" data-testid={testId || `resumen-operativo-${m.id}`}>
      {mat && <span className={`font-medium truncate max-w-[110px] ${m.material_principal.origen === "zona" ? "italic opacity-80" : ""}`} title={m.material_principal.origen === "zona" ? "Material habitual de la zona (sin componentes definidos)" : `${m.material_principal.n_componentes} componente(s)`}>{mat}</span>}
      {med && <span className="opacity-80 font-mono">{med}</span>}
      <RequisitosChips req={req} testId={`req-chips-${m.id}`} />
    </div>
  );
}

/** 👁 con hover/focus (mini preview operativo) y clic → ficha completa. En táctil el clic basta. */
export function OjoOperativo({ m, onVer, className = "", size = "w-3.5 h-3.5", testId }) {
  const comps = m.componentes || [];
  return (
    <HoverCard openDelay={250} closeDelay={80}>
      <HoverCardTrigger asChild>
        <button type="button" onClick={(e) => { e.stopPropagation(); onVer(m); }} className={`p-0.5 rounded hover:bg-zinc-900/60 opacity-70 hover:opacity-100 focus:opacity-100 ${className}`} title="Ver ficha" data-testid={testId || `kanban-ver-${m.id}`} aria-label="Ver ficha del montaje">
          <Eye className={size} />
        </button>
      </HoverCardTrigger>
      <HoverCardContent side="left" align="start" className="w-80 bg-zinc-950 border-zinc-800 text-zinc-100 p-3 text-xs space-y-2" data-testid={`hover-operativo-${m.id}`}>
        <div>
          <div className="font-semibold text-sm truncate">{m.espacio?.nombre || m.cliente_nombre}</div>
          <div className="font-mono text-[10px] text-zinc-400 truncate">{m.peticion?.codigo} · {m.peticion?.nombre}</div>
        </div>
        <div className="grid grid-cols-2 gap-x-3 gap-y-1">
          <div><span className="text-[10px] uppercase text-zinc-500">Qué se monta</span><div>{m.material_principal?.texto || "—"}{m.material_principal?.origen === "zona" ? <span className="text-zinc-500"> (habitual zona)</span> : null}</div></div>
          <div><span className="text-[10px] uppercase text-zinc-500">Componentes</span><div>{comps.length || m.num_componentes || 0}{comps.length ? ` · ${comps.filter((c) => c.listo).length} listos` : ""}</div></div>
          {m.zona && <div><span className="text-[10px] uppercase text-zinc-500">Zona</span><div>{m.zona.nombre}{m.zona.ancho_cm && m.zona.alto_cm ? ` · ${Math.round(m.zona.ancho_cm)}×${Math.round(m.zona.alto_cm)} cm` : ""}</div></div>}
          {m.espacio?.horario && <div><span className="text-[10px] uppercase text-zinc-500">Horario tienda</span><div>{m.espacio.horario}</div></div>}
        </div>
        {m.requisitos_montaje ? <RequisitosDetalle req={m.requisitos_montaje} compacto testId={`hover-req-${m.id}`} /> : <div className="text-zinc-500 italic">Sin requisitos de montaje definidos</div>}
        <div className="text-[10px] text-zinc-500 pt-1 border-t border-zinc-800">Clic para abrir la ficha completa</div>
      </HoverCardContent>
    </HoverCard>
  );
}
